define([
    './_site',
], function(
    Site,
) {
    function AudioPlayer(player) {
        this.$audioPlayer = $(player);
        this.$button = this.$audioPlayer.find('.audio-player__button');
        this.$track = this.$audioPlayer.find('.audio-player__track');
        this.audioSrc = this.$audioPlayer.find('audio').attr('src');
        this.audio = new Audio(this.audioSrc);
        this.duration = null;
        this.progressPercents = 0;

        this.play = function () {
            $(document).trigger('ap:play');

            this.audio.play();
            this.$audioPlayer.attr('data-paused', false);
        };

        this.pause = function () {
            this.audio.pause();
            this.$audioPlayer.attr('data-paused', true);
        };

        this.stop = function () {
            this.pause();
            this.audio.currentTime = 0;
            this.progressPercents = 0;

            this.$audioPlayer.find('.audio-player__progress').css({
                width: this.progressPercents + '%',
            });
        };

        this.init = function () {
            this.$audioPlayer.attr('data-paused', true);

            this.audio.addEventListener('loadedmetadata', function () {
                this.duration = this.audio.duration;
            }.bind(this));

            this.$button.on('click', function () {
                var hasStopped = this.$audioPlayer.attr('data-paused') === 'true';

                if (hasStopped) {
                    this.play();
                } else {
                    this.pause();
                }
            }.bind(this));

            this.$track.on('click', function (event) {
                var track = $(event.currentTarget);
                var width = track.width();
                var offset = track.offset();
                var relativeX = (event.pageX - offset.left);
                var clickedPercent = (relativeX / width);

                this.audio.currentTime = this.duration * clickedPercent;

                /*if (this.audio.paused) {
                    this.play();
                }*/

            }.bind(this));


            this.audio.addEventListener('timeupdate', function () {
                var progressPercents = (this.audio.currentTime / this.duration) * 100;

                this.progressPercents = Math.round(progressPercents);

                this.$audioPlayer.find('.audio-player__progress').css({
                    width: this.progressPercents + '%',
                });
            }.bind(this));

            this.audio.addEventListener('ended', function () {
                this.stop();
            }.bind(this));
        };
    }


    // -------------------
    // BINDS
    // -------------------

    const players = [];

    $('.audio-player').each(function (index, player) {
        players.push(new AudioPlayer(player));
        players[index].init();
    });

    $(document).on('ap:play', function () {
        players.map(function (player) {
            player.pause();
        })
    })
});
